import React, { useState } from 'react';
import { faCheck, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { academicProgramsService } from '../../../../services';
import { Confirm } from '../../../blocks';
import eventEmitter from '../../../../shared/eventEmitter';
import { getChangeStatusApprovalFields } from './programRequestApprovalPayload';

const getDeliveryMode = deliveryMode => {
    if (deliveryMode === null || deliveryMode === undefined) return null;
    if (deliveryMode === 'On Campus and Online') return 3;
    if (deliveryMode === 'On Campus Only') return 1;
    return 2;
};

const getDeliveryModeOnline = deliveryModeOnline => {
    if (deliveryModeOnline === null || deliveryModeOnline === undefined) return null;
    if (deliveryModeOnline === '100% Online') return 1;
    if (deliveryModeOnline === 'Blended') return 2;
    return 0;
};

export const RequestActionFooter = ({ requestLogs, userInput, requestStatus }) => {
    const [confirmApprove, setConfirmApprove] = useState(false);
    const [confirmDeny, setConfirmDeny] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [confirmInstitution, setConfirmInstitution] = useState(false);

    const changeStatus = (statusId, commentsForInstitution = '') => {
        if (!requestLogs || requestLogs.length === 0) return;
        const refLog = requestLogs[0];
        const details = userInput ?? {};
        const locationStatusChanges = details.locations
            ? details.locations.map(loc => ({
                LocationId: loc.locationId,
                LocationName: loc.locationName,
                StatusId: loc.statusId ?? loc.StatusId,
            }))
            : null;
        const postData = {
            degreeLevel: details.degreeLevelId ?? undefined,
            programId: details.programID ?? -1,
            locationStatusChanges,
            formalName: details.programName ?? undefined,
            cipCode: details.cipCode ?? undefined,
            distanceEdApproved: { id: getDeliveryMode(details.deliveryMode) },
            distanceEdOnline: { id: getDeliveryModeOnline(details.deliveryModeOnline) },
            comments: details.comments ?? commentsForInstitution,
            creditRequirementMinimum: details.creditRequirementMinimum
                ? Number(details.creditRequirementMinimum)
                : undefined,
            creditRequirementMaximum: details.creditRequirementMaximum
                ? Number(details.creditRequirementMaximum)
                : undefined,
            institutionId: details.institutionId ?? undefined,
            credential: {
                ProgramURL: details.programURL ?? '',
                Keywords: details.keywords ?? '',
                ProgramDescription: details.description ?? '',
                CredentialName: details.programName ?? undefined,
            },
            ProgramStatusId: details.programStatus,
            ...getChangeStatusApprovalFields(details, requestLogs),
            RequestId: refLog.requestId,
        };
        const res = academicProgramsService.changeProgramRequestStatus(
            refLog.requestId,
            statusId,
            postData
        );
        Promise.resolve(res).then(() => {
            eventEmitter.emit('updateSARData');
        });
    };

    const isFinalized =
        requestStatus === 'Approved' ||
        requestStatus === 'Denied' ||
        requestStatus === 'Deleted';

    return (
        <>
            <div className="request-actions-footer">
                <div className="d-flex justify-content-end">
                    <button
                        type="button"
                        className="btn btn-outline-primary mr-3"
                        disabled={isFinalized}
                        onClick={() => setConfirmInstitution(true)}
                    >
                        <i className="fas fa-undo"></i> Send Back for Institution Review
                    </button>
                    <button
                        type="button"
                        className="btn btn-success mr-3 px-3"
                        disabled={isFinalized}
                        onClick={() => setConfirmApprove(true)}
                    >
                        <FontAwesomeIcon icon={faCheck} /> Approve
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger mr-3 px-3"
                        disabled={isFinalized}
                        onClick={() => setConfirmDeny(true)}
                    >
                        <FontAwesomeIcon icon={faTimes} /> Deny
                    </button>
                    <button
                        type="button"
                        className="btn btn-warning px-3"
                        disabled={isFinalized}
                        onClick={() => setConfirmDelete(true)}
                    >
                        <FontAwesomeIcon icon={faTrash} /> Delete
                    </button>
                </div>
            </div>
            <Confirm
                isOpen={confirmApprove}
                toggle={() => setConfirmApprove(false)}
                onConfirm={() => changeStatus(3)}
                title="Confirm Changes"
                message="Are you sure you want to approve this request?"
            />
            <Confirm
                isOpen={confirmDeny}
                toggle={() => setConfirmDeny(false)}
                onConfirm={() => changeStatus(4)}
                title="Confirm Changes"
                message="Are you sure you want to deny this request?"
            />
            <Confirm
                isOpen={confirmDelete}
                toggle={() => setConfirmDelete(false)}
                onConfirm={() => changeStatus(6)}
                title="Confirm Delete"
                message="Are you sure you want to delete this request?"
            />
            <Confirm
                isOpen={confirmInstitution}
                toggle={() => setConfirmInstitution(false)}
                onConfirm={input => changeStatus(5, input)}
                title="Send back to institution"
                message=""
                addTextBox={true}
                textBoxTitle="Comments"
            />
        </>
    );
};
